/**
 * constants.js - Constantes partagées SamaSalon Frontend
 */

// ─── Rôles utilisateurs ───────────────────────────────────────────────────────
export const ROLES = {
  SUPER_ADMIN: 0,
  ADMIN:       1,
  EMPLOYEE:    5
};

// ─── Devises supportées ───────────────────────────────────────────────────────
export const CURRENCIES = {
  XOF: 'XOF',
  EUR: 'EUR',
  USD: 'USD'
};

// ─── Affichage des devises ────────────────────────────────────────────────────
export const CURRENCY_DISPLAY = {
  XOF: 'FCFA',
  EUR: '€',
  USD: '$'
};

// ─── Types de transactions ────────────────────────────────────────────────────
export const TRANSACTION_TYPES = {
  PRESTATION: 'Prestation', // Service rendu (RDV ou encaissement direct)
  VENTE:      'Vente',      // Vente de produit
  DEPENSE:    'Depense'     // Sans accent - valeur canonique en base
};

// ─── Modes de paiement par devise ─────────────────────────────────────────────
export const PAYMENT_METHODS = {
  XOF: [
    { value: 'Especes',      label: 'Espèces'      },
    { value: 'Wave',         label: 'Wave'          },
    { value: 'Orange Money', label: 'Orange Money'  }
  ],
  EUR: [
    { value: 'Especes', label: 'Espèces'       },
    { value: 'Carte',   label: 'Carte Bancaire' }
  ],
  USD: [
    { value: 'Especes', label: 'Espèces'       },
    { value: 'Carte',   label: 'Carte Bancaire' }
  ]
};

// ─── Clés localStorage ────────────────────────────────────────────────────────
export const STORAGE_KEYS = {
  TOKEN:            'token',
  ROLE:             'role',
  USER_NAME:        'userName',
  ADMIN_ACTIVE_TAB: 'adminActiveTab'
};
